import { useEffect, useState } from 'react';
import { get, post, put } from 'helpers/apiHelpers';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useGetCompanyDefaultLanguage } from 'hooks/redux/Translatable/useTranslatableLanguages';

import FormFiltersView from './FormFilters.view';

const FormFiltersContainer = ({ match, location, history, t }) => {
  const [state, setState] = useState({
    modal: null,
    modalOptions: [],
    name: '',
    packages: [],
    image: null,
    position: 0,
    imageUrl: null,
    active: false,
    description: '',
    disabledDiets: [],
    mainImage: null,
    mainImageUrl: null,
  });

  const [packages, setPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const filterLineDietsId = match.params.id;
  const isEdit = location.pathname.includes('edit');

  const companyDefaultLanguage = useGetCompanyDefaultLanguage();

  useEffect(() => {
    get('/packages', { pagination: false })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(response => {
        setPackages(response['hydra:member']);
      })
      // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks, no-console -- FIXME
      .catch(err => console.log(err));

    if (isEdit) {
      get(`package-line-filters/${filterLineDietsId}`, { translations: true })
        // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
        .then(response => {
          const {
            name,
            // eslint-disable-next-line no-shadow -- FIXME
            packages,
            active,
            position,
            description,
            image,
            mainImage,
          } = response;

          setState(prev => ({
            ...prev,
            name,
            packages,
            active,
            position,
            description,
            image: image?.['@id'] || null,
            imageUrl: image?.contentUrl || null,
            mainImage: mainImage?.['@id'] || null,
            mainImageUrl: mainImage?.contentUrl || null,
          }));
          setIsLoading(true);
        })
        // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks -- FIXME
        .catch(err => {
          // eslint-disable-next-line no-console -- FIXME
          console.log(err);
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
    !isEdit && setIsLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const handleInputChange = (event, value) => {
    const newValue = event.target.value;
    setState(prev => ({
      ...prev,
      [event.target.name]: value || newValue,
    }));
  };

  const handleSelect = ({ target: { name, value } }) => {
    setState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const getImage = (stateName, data) => {
    setState(prev => ({
      ...prev,
      [stateName]: data?.['@id'] || null,
      [`${stateName}Url`]: data?.contentUrl || null,
    }));
  };

  const removeImage = stateName => {
    setState(prev => ({
      ...prev,
      [stateName]: null,
      [`${stateName}Url`]: null,
    }));
  };

  const handleToggle = e => {
    setState(prev => ({ ...prev, [e.target.name]: !state[e.target.name] }));
  };

  const checkIsFormValid = () =>
    state.name['@ContentTranslation'][companyDefaultLanguage] &&
    state.packages.length > 0;

  const showToast = key => toast.error(t(key));

  // eslint-disable-next-line consistent-return -- FIXME
  const handleSubmit = () => {
    if (!checkIsFormValid()) {
      return showToast('form.fillAllRequiredFields');
    }

    if (state.position < 1) {
      return showToast('form.fillAllRequiredFields');
    }

    const data = {
      name: state.name,
      // eslint-disable-next-line radix -- FIXME
      position: parseInt(state.position),
      description: state.description,
      active: state.active,
      image: state.image,
      disabledDiets: state.disabledDiets,
      packages: state.packages,
      mainImage: state.mainImage,
    };
    const action = isEdit
      ? put(`/package-line-filters/${filterLineDietsId}`, data)
      : post('/package-line-filters', data);
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    action.then(() => {
      history.push('/admin/filter-line-diets');
    });
  };

  const props = {
    t,
    packages,
    state,
    isLoading,
    isEdit,
    filterLineDietsId,
    handleInputChange,
    handleSelect,
    getImage,
    removeImage,
    handleToggle,
    handleSubmit,
  };
  return <FormFiltersView props={props} />;
};

export default withTranslation()(FormFiltersContainer);
